import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Icon, Modal} from 'antd';
import BaseComponent from "../../../base/BaseComponent";
import {message} from './Mess'
const {confirm} = Modal;



export default class DownLoad  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentWillMount() {
    }
    componentDidMount() {
    }
    render() {
        let right =  this.props.marginRight?this.props.marginRight: 5;
        return(
            <div style={{marginRight:right}} onClick={() => {
                this.delete()
            }}>{
                this.props.text?<span style={{cursor:"pointer"}}>删除</span>:<Button  icon={"delete"} >删除</Button>
            }
            </div>
        )
    }
    //删除
    delete() {
        let data = this.sysConfigGetValueByKey('recycleAutoDelTime','0');
         data = parseInt(data/(1000 * 60 * 60 * 24))
        let content=`删除的文件可在${data}天内通过回收站还原`;
        if(this.props.IsNotGoToRecycle){
            content=''
        }
        this.props.hideCallBack&&this.props.hideCallBack();
        if (this.props.checkArray.length) {
            confirm({
                title: '确定删除所选文件？',
                content:content,
                onOk:() =>{
                    let ids = [];
                    this.props.checkArray.forEach((item, index) => {
                        if(this.props.IsDefault){
                            ids.push(item.virtualFileId)
                        }else{
                            ids.push(item.id)
                        }
                    });
                    if(this.props.IsTile){
                        this.request({
                            url: "/search-server/search/moveToRecycle",
                            method: "post",
                            body: {
                                thirdIds:ids.join(','),
                            },
                            contentType: "json",
                            callBack: (data) => {
                                if (data) {
                                    message.success('删除成功');
                                    //当前点击的id (props传过去的参数)
                                    //当前的树id
                                    //当前选中的数组
                                    //是否更新当前数据
                                    //是否跳转去第一页
                                    // this.props.callBack&&this.props.callBack(this.props.currentId, this.props.current,this.props.checkArray,true,true);
                                    this.props.callBack&&this.props.callBack()
                                }
                            }
                        });
                    }else{
                        this.request({
                            url: "/cm-sites-storage-management/recycle/batchRemove",
                            method: "post",
                            body: {
                                virtualFileIds:ids.join(','),
                            },
                            contentType: "json",
                            callBack: (data) => {
                                if (data) {
                                    message.success('删除成功');
                                    // this.props.callBack&&this.props.callBack(this.props.currentId, this.props.current,this.props.checkArray,true,true);
                                    this.props.callBack&&this.props.callBack()
                                }
                            }
                        });
                    }


                },
                onCancel() {
                },
            });

        } else {
            message.error('至少选择一个文件夹或者文件！')
        }
    }
}
